/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Ateliere_Connect_Status_Caption_DetailsInputs */

const en_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Getting details for caption file: ${i?.id}...`)
};

const fr_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Récupération des détails du fichier de sous-titres : ${i?.id}...`)
};

const de_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Details zur Untertiteldatei werden abgerufen: ${i?.id}...`)
};

const it_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ottenimento dei dettagli per il file della didascalia: ${i?.id}...`)
};

const ru_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Получение информации о файле с подписями: ${i?.id}...`)
};

const es_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obteniendo detalles del archivo de subtítulos: ${i?.id}...`)
};

const zh_cn2_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在获取标题文件 ${i?.id} 的详细信息...`)
};

const ja_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`キャプション ファイルの詳細を取得しています: ${i?.id}...`)
};

const hi_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कैप्शन फ़ाइल के लिए विवरण प्राप्त करना: ${i?.id}...`)
};

const pt_pt2_ateliere_connect_status_caption_details = /** @type {(inputs: Ateliere_Connect_Status_Caption_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtendo detalhes do arquivo de legenda: ${i?.id}...`)
};

/**
* | output |
* | --- |
* | "Getting details for caption file: {id}..." |
*
* @param {Ateliere_Connect_Status_Caption_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_caption_details = /** @type {((inputs: Ateliere_Connect_Status_Caption_DetailsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Caption_DetailsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_caption_details(inputs)
	if (locale === "de") return de_ateliere_connect_status_caption_details(inputs)
	if (locale === "it") return it_ateliere_connect_status_caption_details(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_caption_details(inputs)
	if (locale === "es") return es_ateliere_connect_status_caption_details(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_caption_details(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_caption_details(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_caption_details(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_caption_details(inputs)
	return en_ateliere_connect_status_caption_details(inputs)
});